import { GestureControl, WidgetManager, } from '../CoreModules';
/**
 * Abstract base class for all command controllers for a service
 */
export class Service {
    /**
     * Construct a new Service.
     *
     * @param modules Core modules accessible by each command
     */
    constructor(modules) {
        /**
         * Three-JS Renderer
         */
        Object.defineProperty(this, "renderer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Interface for handling 2D draw calls
         */
        Object.defineProperty(this, "draw2D", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Framework for batching raw mesh objects for efficient rendering
         */
        Object.defineProperty(this, "meshBatch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Framework for mesh instancing
         */
        Object.defineProperty(this, "meshInstance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Framework for drawing labels
         */
        Object.defineProperty(this, "labelManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Manages the callbacks for each gesture type
         */
        Object.defineProperty(this, "gestures", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Manages the creation of 3D world-space widgets
         */
        Object.defineProperty(this, "widgetManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.renderer = modules.renderer;
        this.draw2D = modules.draw2D;
        this.meshBatch = modules.meshBatch;
        this.meshInstance = modules.meshInstance;
        this.labelManager = modules.labelManager;
        this.gestures = new GestureControl(this.renderer.getCanvas());
        this.widgetManager = new WidgetManager(this.renderer, this.meshInstance, this.gestures);
    }
}
